module.exports = "/assets/data/1696621c64e1a78066b2b800831868d9-SA18.data.json";